import { Directive, inject, Input } from '@angular/core';
import { Store } from '@sama/app-state';
import { isEqual } from 'lodash';
import { DebouncedEventTracker } from '../../../../cross-team-shared/event-tracking/debounced-event-tracker';
import { TrackingEvent } from '../../../../cross-team-shared/event-tracking/event-utils';
import { EventTrackingService } from '../../../../shared/event-tracking/event-tracking.service';

@Directive()
export class AbstractInputSettings<T> {
  @Input({ required: true }) defaultValue!: T;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) settingStore!: Store<T>;
  @Input({ required: true }) trackingEvent!: TrackingEvent;

  protected eventTracker = new DebouncedEventTracker(
    this.trackingEvent,
    inject(EventTrackingService),
  );

  reset() {
    if (isEqual(this.settingStore.state(), this.defaultValue)) {
      return;
    }

    this.setValueAndTrackEvent(this.defaultValue);
  }

  protected setValueAndTrackEvent(value: T) {
    this.settingStore.set(value);
    this.eventTracker.trackWithDebounce({
      ...this.trackingEvent,
      new_value: value,
    });
  }
}
